//#region src/integrations/perplexity/perplexityTypes.ts
const PERPLEXITY_INTEGRATION_ID = "perplexity";

//#endregion
export { PERPLEXITY_INTEGRATION_ID };
//# sourceMappingURL=perplexityTypes.js.map